import { commonConfig } from "@/utils/config";

import AppContainer from "@/components/AppContainer";
import AppLink from "@/components/AppLink";
import AppTypography from "@/components/AppTypography";
import AppContent from "@/components/AppContent";
import GeneralActionBar from "./components/GeneralActionBar";
import ProductCategoryMenu from "./components/ProductCategoryMenu";

import { useTranslation } from "next-i18next";

import useStyles from "./MainFooter.styles";

const MainFooter = () => {
  const { t } = useTranslation();

  const { classes } = useStyles();

  return (
    <footer>
      <AppContent>
        <ProductCategoryMenu />
        <div className={classes.socialMedia}>
          <AppContainer>
            <AppTypography
              className={classes.socialMediaTitle}
              variant="bodyMed16"
            >
              {t("followUs")}
            </AppTypography>
            <div className={classes.socialMediaList}>
              <AppLink
                href={commonConfig.FACEBOOK_PAGE_URL}
                variant="bodyReg16"
                underline="hover"
                target="_blank"
              >
                Facebook
              </AppLink>
              <AppTypography variant="bodyReg16">•</AppTypography>
              <AppLink
                href={commonConfig.INSTAGRAM_PAGE_URL}
                variant="bodyReg16"
                underline="hover"
                target="_blank"
              >
                Instagram
              </AppLink>
              <AppTypography variant="bodyReg16">•</AppTypography>
              <AppLink
                href={commonConfig.LINKED_PAGE_URL}
                variant="bodyReg16"
                underline="hover"
                target="_blank"
              >
                Linkedin
              </AppLink>
            </div>
          </AppContainer>
        </div>
        <div className={classes.trustmark}>
          <AppContainer>
            <a
              href="https://hktrustmark.org/badge/5c323c96-4645-4373-8f36-210630b85072"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://hktrustmark.org/api/badges/f7278294c6377d3706b11fba67f5d6c5b36559da8e6a1ef8?d=d758d18600683d9b"
                alt="Hong Kong Trustmark — Verified Member"
                width={260}
                height={110}
                style={{ border: "none", display: "block" }}
              />
            </a>
          </AppContainer>
        </div>
      </AppContent>
      <GeneralActionBar />
    </footer>
  );
};

export default MainFooter;
